export const HAKLAI_PRISA_LABELS = Object.freeze({
  sectionTitle: "פריסה",
  shouldTryPrisa: "האם לבצע פריסת שבח",
  soldPropertyDate: "תאריך מכירת הנכס",
  datePropertyBought: "תאריך רכישת הנכס",
  clientsCount: "לכמה לקוחות לחלק את השבח",
  clientName: "שם לקוח",
  birthOfClient: "תאריך הלידה של הנישום",
  yearsCount: "מספר שנים לפריסה",
  maximalSaleYearCalculation: "חישוב מקסימלי לשנת המכירה",
  creditPointGender: "מין",
  creditPointResidency: "תושבות",
  calculateCreditPoints: "חשב נקודות זיכוי",
  calculatedCreditPointsTooltip: "מילוי נקודות הזיכוי לפי מין ותושבות",
  selectPlaceholder: "בחר",
  male: "גבר",
  female: "אישה",
  israeliResident: "תושב ישראל",
  foreignResident: "תושב חוץ",
  taxYear: "שנת מס",
  income: "הכנסה",
  creditPoints: "נקודות זיכוי",
  yes: "כן",
  no: "לא"
});

export const HAKLAI_PRISA_MESSAGES = Object.freeze({
  preCalcRequired: "יש להשלים את פרטי העסקה והרכישה לפני ביצוע פריסה",
  sameSalePurchaseYearUnavailable: "פריסה אינה זמינה כאשר שנת המכירה זהה לשנת הרכישה",
  partialPurchaseInSaleYearUnavailable: "פריסה אינה זמינה כאשר אחד מחלקי הרכישה נרכש בשנת המכירה"
});

export const HAKLAI_PRISA_ERRORS = Object.freeze({
  birthOfClientRequired: "תאריך הלידה של הנישום הינו שדה חובה",
  birthOfClientInvalid: "תאריך הלידה של הנישום אינו תקין",
  birthOfClientFuture: "תאריך הלידה של הנישום לא יכול להיות תאריך עתידי",
  birthOfClientAfterSale: "תאריך הלידה של הנישום לא יכול להיות לאחר תאריך המכירה",
  birthOfClientTooOld: "תאריך הלידה של הנישום לא יכול להיות יותר ממאה שנה אחורה",
  personsRequired: "יש לבחור מספר לקוחות",
  yearsRequired: "יש להזין מספר שנים לפריסה",
  incomeRequired: "יש להזין הכנסה על מנת לבצע פריסה",
  creditPointsRequired: "יש להזין נקודות זיכוי על מנת לבצע פריסה",
  creditPointsInvalid: "כמות לא חוקית של נקודות זיכוי"
});

export const getHaklaiPrisaPersonTitle = (index) => `פריסה מספר ${index + 1}`;

export const getHaklaiPrisaYearsBackLabel = (years) => (
  years === 1 ? "שנה אחת אחורה" : `${years} שנים אחורה`
);
